export const calculatePercentage = (value, percentage) => {
  return Number(((value / 100) * percentage).toFixed(0))
}

export const toPercent = (value) => `${value * 100}%`
